<template>
    <div class="d-flex align-center">
        <v-chip small label :color="reporte.total > 0 ? 'primary': 'error'" class="font-weight-bold mr-1">
            {{ reporte.total | currency(reporte.divisa_code) }} <template v-if="reporte.percent"><span class="mx-2">/</span>{{ reporte.percent | percent }}</template>
        </v-chip>
        <div v-if="reporte.comparison?.total" class="d-flex text-caption" :class="{
            'accent--text': reporte.comparison.total[1] >= 0,
            'error--text': reporte.comparison.total[1] < 0,
        }">
            <div class="ml-1">{{ reporte.comparison.total[0] | percent }}</div>
            <v-icon v-if="reporte.comparison.total[1] >= 0" color="accent" small>mdi-trending-up</v-icon>
            <v-icon v-else color="error" small>mdi-trending-down</v-icon>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        reporte: {
            required: true
        }
    }
}
</script>